var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Sands4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1400 700",
    id: "svg13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter228722",
    x: -0.0031151247,
    y: -0.052296651,
    width: 1.0062302,
    height: 1.1045933,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.8171561,
    id: "feGaussianBlur2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter228722)",
    style: {
      mixBlendMode: "normal"
    },
    id: "g9"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 616.61c470.58 29.154 861.93 49.282 1400 0v83.393h-1400z",
    fill: "#e49859",
    strokeDashoffset: 45,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    id: "path7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Sands4);
export default __webpack_public_path__ + "static/media/404sands4.468c7de40bce99be867d8647806c0af8.svg";
export { ForwardRef as ReactComponent };